import React, { useEffect, useState, useCallback, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getPagosByUser_Id, updateUser, bloquearUsuarioBy_Id, updatePagoBy_Id, desbloquearUsuarioBy_Id, getPesoByUser_Id, getRuta, createPeso, putEjercicioByEjercicio_Id, deletePesoBy_Id,  createEjercicio, deleteEjercicioBy_Id, createPago, getEjercicioByUser_Id, getAsistenciaByUser_Id, getUsuarioByUser_Id, getUsers, createAsistencia } from "../api";
import UserDetailsForm from "../components/UserDetailsForm";
import UserPagoForm from "../components/UserPagoForm";
import UserPagoVerFormCoach from "../components/UserPagoVerFormCoach";
import UserAsistenciaForm from "../components/UserAsistenciaForm";
import UserEjercicioVerForm from "../components/UserEjercicioVerForm";
import UserEjercicioForm from "./UserEjercicioForm";
import UserPesoVerForm from "../components/UserPesoVerForm";
import UserPesoForm from "./UserPesoForm";
import UsuarioVerForm from "./UsuarioVerForm";
import Banner from "../components/Banner";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faBars } from "@fortawesome/free-solid-svg-icons";

const AdminPage = () => {
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const navigate = useNavigate();
  const location = useLocation();
  const { userData } = location.state || {};
  const [showEjercicioSubMenu, setShowEjercicioSubMenu] = useState(false);
  const [showPesoSubMenu, setShowPesoSubMenu] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [ejercicios, setEjercicios] = useState([]);
  const [pesos, setPesos] = useState([]);
  const [users, setUsers] = useState([]);
  const [pagos, setPagos] = useState([]);
  const [asistencias, setAsistencias] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedSection, setSelectedSection] = useState("Todos"); // Default section

  // Referencias para los menús
  const ejercicioMenuRef = useRef(null);
  const pesoMenuRef = useRef(null);

  // Fetch user data
  const loadUsers = useCallback(async () => {
    try {
      setLoading(true);
      await new Promise(resolve => setTimeout(resolve, 500));
      const { data } = await getUsuarioByUser_Id(userData[0].id_usuario);

      setUsers(data);
    } catch (error) {
      console.error("Error loading users:", error);
    } finally {
      setLoading(false);
    }
  }, [userData]);

  // Fetch pagos data
  const loadPagos = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await getPagosByUser_Id(userData[0].id_usuario);
      setPagos(data);
    } catch (error) {
      console.error("Error loading pagos:", error);
    } finally {
      setLoading(false);
    }
  }, [userData]);

    // Fetch pagos data
    const loadAsistencias = useCallback(async () => {
      try {
        setLoading(true);
        const { data } = await getAsistenciaByUser_Id(userData[0].id_usuario);
        setAsistencias(data);
      } catch (error) {
        console.error("Error loading asistencias:", error);
      } finally {
        setLoading(false);
      }
    }, [userData]);

  // Fetch ejercicios data (adjust as needed for Agregar/Ver)
  const loadEjercicios = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await getEjercicioByUser_Id(userData[0].id_usuario);

      setEjercicios(data);
    } catch (error) {
      console.error("Error loading ejercicios:", error);
    } finally {
      setLoading(false);
    }
  }, [userData]);

    // Fetch ejercicios data (adjust as needed for Agregar/Ver)
    const loadPesos = useCallback(async () => {
      try {
        setLoading(true);
        const { data } = await getPesoByUser_Id(userData[0].id_usuario);
        setPesos(data);
      } catch (error) {
        console.error("Error loading ejercicios:", error);
      } finally {
        setLoading(false);
      }
    }, [userData]);

  useEffect(() => {
    if (userData) {
      loadUsers();
      loadPagos();
      loadAsistencias();
      loadEjercicios();
      loadPesos();
    }
  }, [loadUsers, loadPagos,  loadEjercicios, loadPesos, loadAsistencias, userData]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        ejercicioMenuRef.current && 
        !ejercicioMenuRef.current.contains(event.target) && 
        pesoMenuRef.current &&
        !pesoMenuRef.current.contains(event.target)
      ) {
        setShowEjercicioSubMenu(false);
        setShowPesoSubMenu(false);
      }
    };
    window.addEventListener("click", handleClickOutside);
    return () => {
      window.removeEventListener("click", handleClickOutside);
    };
  }, []);

  if (loading) {
    return <div className="loader"></div>;
  }

  const handleLogoutRedirect = () => {
    navigate("/");
  };

  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

    // Ocultar el menú automáticamente al hacer clic en cualquier opción
  const handleMenuOptionClick = (section) => {
      setIsMenuOpen(false); 
      setSelectedSection({ section }); // Asume que esta función está definida en tu contexto o componente padre
    }

  const toggleEjercicioSubMenu = () => {
    setShowEjercicioSubMenu((prevShowEjercicioSubMenu) => !prevShowEjercicioSubMenu);
  };

  const togglePesoSubMenu = () => {
    setShowPesoSubMenu((prevShowPesoSubMenu) => !prevShowPesoSubMenu);
  };

  const renderSection = () => {
    switch (selectedSection.section) {
      case "Mi_Usuario":
        return <UserDetailsForm user={users[0]} getUsers={getUsers} updateUser={updateUser} loadUsers={loadUsers}/>;
      case "Todos":
        return <UsuarioVerForm user={users[0]}  getUsers={getUsers} setSelectedSection={setSelectedSection} />;
      case "Pagos":
        return <UserPagoForm user={users[0]} pagos={pagos} createPago={createPago} />;
      case "Pagos_especificos":
        const users2=selectedSection.userId
        const nombre_completo=selectedSection.nombre_completo
        return <UserPagoVerFormCoach user={users2} getPagosByUser_Id={getPagosByUser_Id} nombre_completo={nombre_completo} updatePagoBy_Id={updatePagoBy_Id}/>;
      case "Asistencia":
        return (
          <UserAsistenciaForm
            user={users[0]}
            asistencias={asistencias}
            getRuta={getRuta}
            createAsistencia={createAsistencia}
          />
        );
      case "Ejercicio_Agregar":
        return (
          <UserEjercicioForm
            user={users[0]}
            ejercicios={ejercicios}
            createEjercicio={createEjercicio}
          />
        );
      case "Ejercicio_Ver":
        return (
          <UserEjercicioVerForm
            user={users[0]}
            ejercicios={ejercicios}
            getEjercicioByUser_Id={getEjercicioByUser_Id}
            deleteEjercicioBy_Id={deleteEjercicioBy_Id}
            putEjercicioByEjercicio_Id={putEjercicioByEjercicio_Id}
          />
        );
        case "Peso_Agregar":
          return (
            <UserPesoForm
              user={users[0]}
              pesos={pesos}
              createPeso={createPeso}
            />
          );
        case "Peso_Ver":
          return (
            <UserPesoVerForm
              user={users[0]}
              pesos={pesos}
              getPesoByUser_Id={getPesoByUser_Id}
              deletePesoBy_Id={deletePesoBy_Id}
            />
          );
      default:
        return <UsuarioVerForm user={users[0]}  getUsers={getUsers} setSelectedSection={setSelectedSection} bloquearUsuarioBy_Id={bloquearUsuarioBy_Id} desbloquearUsuarioBy_Id={desbloquearUsuarioBy_Id} />;
    }
  };

  return (
    <div>
      {loading || !users ? (
        <div className="loader"></div>
      ) : (
        <div className="container">
          <Banner />
          <p>Bienvenido Coach<br></br>
          {userData[0].nombre_completo}<br></br>
          Numero Halcon:
          <b><h1>{userData[0].id_usuario}</h1></b>
          Padrino: {userData[0].padrino} <br></br>
          Reto:<b> {userData[0].reto}</b><br></br>
          Estado de reto: {userData[0].estado_reto}<br></br><br></br></p>
          <center><i><b>{userData[0].frase_del_dia}</b></i></center>
          
          <div className="container3">
            <img src={`${apiBaseUrl}${userData[0].path_imagen}`} 
              width="75px" alt={`${apiBaseUrl}${userData[0].path_imagen}`} 
              className="cute-border">
            </img>
          </div>

          <div className="menu-bar">
            <button className="hamburger-button" onClick={toggleMenu}>
              <FontAwesomeIcon icon={faBars} />
            </button>

            <div className={`menu-content ${isMenuOpen ? 'show' : ''}`}>
              <button className="menu-button" onClick={() => handleMenuOptionClick("Todos")}>Todos</button>
              <button className="menu-button" onClick={() => handleMenuOptionClick("Pagos")}>Pagos</button>
              
              <button className="menu-button" onClick={toggleEjercicioSubMenu} ref={ejercicioMenuRef}>
                Ejercicio <FontAwesomeIcon icon={faChevronDown} />
              </button>
              <div className={`dropdown-ejercicio ${showEjercicioSubMenu ? "show" : ""}`}>
                <button className="dropdown-content" onClick={() => handleMenuOptionClick("Ejercicio_Agregar")}>Agregar</button>
                <button className="dropdown-content" onClick={() => handleMenuOptionClick("Ejercicio_Ver")}>Ver</button>
              </div>


              <button className="menu-button" onClick={togglePesoSubMenu} ref={pesoMenuRef}>
                Peso <FontAwesomeIcon icon={faChevronDown} />
              </button>
              <div className={`dropdown-peso ${showPesoSubMenu ? "show" : ""}`}>
                <button className="dropdown-content" onClick={() => handleMenuOptionClick("Peso_Agregar")}>Agregar</button>
                <button className="dropdown-content" onClick={() => handleMenuOptionClick("Peso_Ver")}>Ver</button>
              </div>

              <button className="menu-button" onClick={() => handleMenuOptionClick("Mi_Usuario")}>Mi Usuario</button>
              <button className="menu-button" onClick={handleLogoutRedirect}>Salir</button>
            </div>
          </div>
          <div>{renderSection()}</div>
        </div>
      )}
    </div>
  );
};

export default AdminPage;
